import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import HomePage from '../pages/HomePage';
import CategoryPage from '../pages/CategoryPage';
import Dashboard from '../pages/dashboard/Dashboard';
import PartyManagement from '../pages/dashboard/PartyMangement'
import DashboardLayout from '../pages/dashboard/DashboardLayout';
import BillManagement from '../pages/dashboard/BillManagement';
import AccountsPage from '../pages/AccountsPage';
import BankPage from '../pages/BankPage';
import RojmiManagement from '../pages/dashboard/RojmiManagement';
import DailyTransaction from '../pages/dashboard/DailyTransaction';
import Employees from '../pages/dashboard/Employee';
import UdharManagement from '../pages/dashboard/UdharManagement';
import EmployeeDetails from '../pages/dashboard/EmployeeDetails';
import ParcelManagement from '../pages/dashboard/ParcelManagement';
import BhishiManagement from '../pages/dashboard/BhishiManagement';
import BhishiGroupDetails from '../pages/dashboard/BhishiGroupDetails';
import SalaryManagement from '../pages/dashboard/SalaryManagement';

const AppRoutes = () => {
  const location = useLocation();

  return (
    <Routes>
      {/* Public site routes */}
      <Route path="/" element={<HomePage />} />

      {/* Category Pages */}
      <Route
        path="/women"
        element={
          <CategoryPage
            key={location.pathname}
            currentPath={location.pathname}
            title="Women's Fashion"
            description="Elegance crafted for every occasion. Discover sarees, kurtis, and more."
            heroImage="/images/gallary/women_banner.png"
            galleryImages={[
              "/images/gallary/women_gallery_1.png",
              "/images/gallary/women_gallery_2.png",
              "/images/gallary/women_gallery_3.png",
              "/images/gallary/women_gallery_4.png",
              "/images/gallary/women_gallery_5.png",
              "/images/gallary/women_gallery_6.png"

            ]}
          />
        }
      />
      <Route
        path="/men"
        element={
          <CategoryPage
            key={location.pathname}
            currentPath={location.pathname}
            title="Men's Connection"
            description="Sophisticated styles for the modern man."
            heroImage="/images/gallary/men_banner.png"
            galleryImages={[
              "/images/gallary/men_gallery_1.png",
              "/images/gallary/men_gallery_2.png",
              "/images/gallary/men_gallery_3.png",
              "/images/gallary/men_gallery_4.png",
              "/images/gallary/men_gallery_5.png",
              "/images/gallary/men_gallery_6.png"
            ]}
          />
        }
      />
      <Route
        path="/kids"
        element={
          <CategoryPage
            key={location.pathname}
            currentPath={location.pathname}
            title="Kids' Corner"
            description="Playful and comfortable outfits for your little ones."
            heroImage="/images/gallary/kids_banner.png"
            galleryImages={[
              "/images/gallary/kids_gallery_1.png",
              "/images/gallary/kids_gallery_2.png",
              "/images/gallary/kids_gallery_3.png",
              "/images/gallary/kids_gallery_4.png",
              "/images/categories/kids.jpg",
              "/images/hero_section/kids_hero_slide1.png"
            ]}
          />
        }
      />
      <Route
        path="/collections"
        element={
          <CategoryPage
            key={location.pathname}
            currentPath={location.pathname}
            title="Exclusive Settings"
            description="Our premium selection of wedding and festive wear."
            heroImage="/images/gallary/collection_banner.png"
            galleryImages={[
              "/images/gallary/collection_gallery_1.png",
              "/images/gallary/collection_gallery_2.png",
              "/images/categories/saree.jpg",
              "/images/hero_section/family_slide_5.png"
            ]}
          />
        }
      />

      {/* Dashboard layout with nested routes */}
      <Route path='/dashboard' element={<DashboardLayout />}>
        <Route index element={<Dashboard />} />
        <Route path='parties' element={<PartyManagement />} />
        <Route path="parties/bills/:partyId" element={<BillManagement />} />
        <Route path="accounts" element={<AccountsPage />} />

        <Route path="accounts/bank/:accountId" element={<BankPage />} />
        <Route path="rojmi" element={<RojmiManagement />} />
        <Route path="rojmi/udhar" element={<UdharManagement />} />
        <Route path="daily-transaction" element={<DailyTransaction />} />
        <Route path="employees" element={<Employees />} />
        <Route path="employees/:id" element={<EmployeeDetails />} />
        <Route path="salary" element={<SalaryManagement />} />
        <Route path="parcels" element={<ParcelManagement />} />
        <Route path="bhishi" element={<BhishiManagement />} />
        <Route path="bhishi/:id" element={<BhishiGroupDetails />} />
      </Route>


      {/* Catch all - Redirect to Home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes >
  )
}

export default AppRoutes;